type MenuItemType = {
  slug: string
  label: string
  icon: string
  url: string
  children?: MenuItemType[]
}

export const menuItems: MenuItemType[] = [
  { slug: 'overview', label: 'Overview', icon: 'gauge', url: '/app/overview' },
  { slug: 'tickets', label: 'Tickets', icon: 'ticket', url: '/app/tickets/list' },
  { slug: 'customers', label: 'Customers', icon: 'users', url: '/app/customers/list' },
  { slug: 'drivers', label: 'Drivers', icon: 'truck', url: '/app/drivers/list' },
  { slug: 'routes', label: 'Routes', icon: 'route', url: '/app/routes/list' },
  { slug: 'settings', label: 'Settings', icon: 'cog', url: '/app/settings' },
]
